import React from 'react';
import { DownloadIcon, BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
const items = [{
  icon: DownloadIcon,
  title: 'Acceso inmediato',
  text: 'Descargas el PDF justo después de tu compra.'
}, {
  icon: BookOpenIcon,
  title: 'A tu propio ritmo',
  text: 'Léela cuando quieras, en el móvil, en papel o en tu tablet.'
}, {
  icon: ShieldCheckIcon,
  title: 'Sin riesgo',
  text: 'Si no es para ti, te devolvemos tu dinero en 14 días.'
}];
export function Guarantee() {
  return <section className="w-full border-t border-ink/5 bg-ivory py-16 sm:py-20" aria-labelledby="garantia-title" data-id="element-30" data-mp="14gz3ki9um9fd">
      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-31" data-mp="1j6n8dth8nq7u">
        <h2 id="garantia-title" className="text-center font-serif text-2xl text-ink sm:text-3xl" data-id="element-32" data-mp="1ecsputdddhac">
          Un paso pequeño, sin letra pequeña
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-10 sm:grid-cols-3" data-id="element-33" data-mp="lpoe85jru4pl">
          {items.map(({
          icon: Icon,
          title,
          text
        }) => <div key={title} className="text-center" data-id="element-34" data-mp="oz05a0jmgaqy">
              <Icon className="mx-auto h-6 w-6 text-gold-deep" strokeWidth={1.5} aria-hidden="true" data-id="element-35" data-mp="tycrqk6kzft0" />
              <h3 className="mt-4 font-serif text-xl text-ink" data-id="element-36" data-mp="yrfnmyytz1cd">{title}</h3>
              <p className="mt-2 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-37" data-mp="12pmun23hsoad">
                {text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}